import React from 'react';
import {useRef} from 'react';

import {motion} from 'framer-motion';
import {useInView} from 'framer-motion';
import {useIntl} from 'react-intl';

export const VideoSection4: React.FC<React.PropsWithChildren<unknown>> = () => {
  const intl = useIntl();
  const ref = useRef(null);
  const isInView = useInView(ref, {once: true, amount: 0.3});

  return (
    <section
      ref={ref}
      className="py-20 bg-gradient-to-br from-gray-900 to-black text-white"
    >
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <motion.div
          className="text-center mb-16"
          // initial={{opacity: 0, y: 50}}
          // animate={isInView ? {opacity: 1, y: 0} : {}}
          // transition={{duration: 0.8, ease: 'easeOut'}}
        >
          <h2 className="text-4xl md:text-6xl font-light mb-6">
            {intl.formatMessage({id: 'home.videoSection4.title'})}
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            {intl.formatMessage({id: 'home.videoSection4.description'})}
          </p>
        </motion.div>

        {/* Video grid with multiple clips */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Main video */}
          <motion.div
            className="relative"
            // initial={{opacity: 0, scale: 0.9}}
            // animate={isInView ? {opacity: 1, scale: 1} : {}}
            // transition={{duration: 0.8, delay: 0.3}}
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-80 object-cover"
              >
                <source src="/images/stryd5/clips.mp4" type="video/mp4" />
              </video>

              {/* Floating text overlay */}
              {/* <motion.div
                className="absolute top-6 left-6 bg-white/10 backdrop-blur-md rounded-xl px-4 py-3 border border-white/20"
                initial={{opacity: 0, y: 20}}
                animate={isInView ? {opacity: 1, y: 0} : {}}
                transition={{duration: 0.6, delay: 0.8}}
              >
                <div className="text-white font-semibold text-lg">
                  Four Color Clips
                </div>
                <div className="text-white/80 text-sm">New Blue & Gray options</div>
              </motion.div>

              <motion.div
                className="absolute bottom-6 right-6 bg-blue-600/90 backdrop-blur-md rounded-xl px-4 py-3"
                initial={{opacity: 0, y: 20}}
                animate={isInView ? {opacity: 1, y: 0} : {}}
                transition={{duration: 0.6, delay: 1.0}}
              >
                <div className="text-white font-semibold text-lg">
                  Fresh Look
                </div>
                <div className="text-white/90 text-sm">Modern gray finish</div>
              </motion.div> */}
            </div>
          </motion.div>

          {/* Content side */}
          <motion.div
            className="flex flex-col justify-center space-y-8"
            // initial={{opacity: 0, x: 50}}
            // animate={isInView ? {opacity: 1, x: 0} : {}}
            // transition={{duration: 0.8, delay: 0.5}}
          >
            {/* Color options */}
            <div className="space-y-6">
              <h3 className="text-2xl font-semibold text-white mb-4">
                {intl.formatMessage({id: 'home.videoSection4.sectionTitle'})}
              </h3>

              <motion.div
                className="flex gap-4"
                // initial={{opacity: 0, y: 20}}
                // animate={isInView ? {opacity: 1, y: 0} : {}}
                // transition={{duration: 0.6, delay: 0.8}}
              >
                <div className="w-16 h-16 bg-blue-400 rounded-xl flex items-center justify-center">
                  <span className="text-white font-bold text-sm">
                    {intl.formatMessage({id: 'home.videoSection4.colorBlue'})}
                  </span>
                </div>
                <div className="w-16 h-16 bg-gray-600 rounded-xl flex items-center justify-center">
                  <span className="text-white font-bold text-sm">
                    {intl.formatMessage({id: 'home.videoSection4.colorGray'})}
                  </span>
                </div>
                <div className="w-16 h-16 bg-black rounded-xl flex items-center justify-center">
                  <span className="text-white font-bold text-sm">
                    {intl.formatMessage({id: 'home.videoSection4.colorBlack'})}
                  </span>
                </div>
                <div className="w-16 h-16 bg-orange-400 rounded-xl flex items-center justify-center">
                  <span className="text-white font-bold text-sm">
                    {intl.formatMessage({id: 'home.videoSection4.colorOrange'})}
                  </span>
                </div>
              </motion.div>

              <motion.p
                className="text-gray-300 leading-relaxed"
                // initial={{opacity: 0, y: 20}}
                // animate={isInView ? {opacity: 1, y: 0} : {}}
                // transition={{duration: 0.6, delay: 1.0}}
              >
                {intl.formatMessage({
                  id: 'home.interactiveHardware.feature6Description',
                })}
              </motion.p>
            </div>

            {/* Features list */}
            <motion.div
              className="space-y-4"
              // initial={{opacity: 0, y: 20}}
              // animate={isInView ? {opacity: 1, y: 0} : {}}
              // transition={{duration: 0.6, delay: 1.2}}
            >
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                <span className="text-gray-300">
                  {intl.formatMessage({id: 'home.videoSection4.feature1'})}
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                <span className="text-gray-300">
                  {intl.formatMessage({id: 'home.videoSection4.feature2'})}
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-purple-400 rounded-full"></div>
                <span className="text-gray-300">
                  {intl.formatMessage({id: 'home.videoSection4.feature3'})}
                </span>
              </div>
            </motion.div>
          </motion.div>
        </div>

        {/* Bottom CTA */}
        {/* <motion.div
          className="mt-16 text-center"
          initial={{opacity: 0, y: 30}}
          animate={isInView ? {opacity: 1, y: 0} : {}}
          transition={{duration: 0.8, delay: 1.4}}
        >
          <motion.button
            className="bg-white text-black px-8 py-4 rounded-2xl font-semibold hover:bg-gray-100 transition-colors duration-300"
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.95}}
          >
            Explore Color Options
          </motion.button>
        </motion.div> */}
      </div>
    </section>
  );
};
